export const en = {
  // Header
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    gallery: 'Gallery',
    testimonials: 'Testimonials',
    contact: 'Contact',
    whatsapp: 'WhatsApp'
  },

  // Home Page
  home: {
    hero: {
      title: 'Transform Your Space with',
      titleHighlight: 'Quality Floors & Tiles',
      tagline: 'Professional installation of floors and tiles with perfect finishing',
      ctaQuote: 'Request Quote',
      ctaGallery: 'View Gallery'
    },
    stats: {
      experience: 'Years of Experience',
      projects: 'Completed Projects',
      satisfaction: 'Satisfied Clients'
    },
    servicesSection: {
      title: 'Our Services',
      subtitle: 'We offer complete solutions in floors and tiles to transform your space'
    },
    whyUs: {
      title: 'Why Choose Us?',
      subtitle: 'Commitment to quality and customer satisfaction',
      benefits: [
        'Experienced and qualified professionals',
        'Top quality materials',
        'Impeccable and detailed finishing',
        'Transparent pricing with no surprises',
        'Strict deadline compliance',
        '1-year warranty on all services'
      ]
    },
    testimonialsSection: {
      title: 'What Our Clients Say',
      subtitle: 'Real experiences from those who trusted our work'
    },
    cta: {
      title: 'Ready to Transform Your Space?',
      subtitle: 'Contact us now and request a free quote with no obligation',
      button: 'Chat on WhatsApp'
    }
  },

  // About Page
  about: {
    title: 'About Us',
    subtitle: 'Learn about our story and commitment to quality and customer satisfaction',
    historyTitle: 'Our Story',
    description: 'We are specialists in floor and tile installation with over 10 years of market experience. Our highly qualified team offers high-quality services, always prioritizing perfect finishing and customer satisfaction.',
    description2: 'With a dedicated and passionate team, we constantly seek excellence in every project. We use modern techniques and top-quality materials to ensure durability and beauty in our work.',
    valuesTitle: 'Our Values',
    values: {
      quality: { title: 'Quality', desc: 'Commitment to excellence in every detail of our work' },
      professionalism: { title: 'Professionalism', desc: 'Qualified team trained to serve with excellence' },
      precision: { title: 'Precision', desc: 'Attention to detail and impeccable finishing in every project' },
      satisfaction: { title: 'Satisfaction', desc: 'Customer at the center of everything we do' }
    },
    statsTitle: 'Our Numbers',
    whyUsTitle: 'Why Choose Us?',
    reasons: [
      { title: 'Proven Experience', desc: 'Over a decade in the market with hundreds of successful projects.' },
      { title: 'Quality Materials', desc: 'We only use certified materials from trusted suppliers.' },
      { title: 'Qualified Team', desc: 'Trained professionals in constant technical updating.' },
      { title: 'Personalized Service', desc: 'Each project is unique and receives special attention from our team.' },
      { title: 'Warranty & Support', desc: 'We offer 1-year warranty on all our services.' },
      { title: 'Deadlines Met', desc: 'Commitment to the established schedule from the beginning.' }
    ]
  },

  // Services Page
  services: {
    title: 'Our Services',
    subtitle: 'Complete solutions in floors and tiles for all types of spaces',
    processTitle: 'Our Process',
    process: [
      { title: 'Initial Consultation', desc: 'Contact us and schedule a free technical visit' },
      { title: 'Quote', desc: 'We prepare a detailed quote with no obligation' },
      { title: 'Execution', desc: 'Our team performs the service with quality and punctuality' },
      { title: 'Delivery', desc: 'We finish with complete cleaning and service warranty' }
    ],
    differentialsTitle: 'Differentials',
    differentials: [
      { title: 'Premium Materials', desc: 'We only use high-quality floors and tiles and certified materials' },
      { title: 'Specialized Team', desc: 'Professionals with years of experience and constant training' },
      { title: 'Extended Warranty', desc: '1-year warranty on all services performed' },
      { title: 'Fast Service', desc: 'We respond quickly and schedule visits promptly' },
      { title: 'Total Cleaning', desc: 'We leave the environment clean and organized after completion' },
      { title: 'Fair Price', desc: 'Transparent quotes with no hidden costs' }
    ],
    ctaTitle: 'Interested in Our Services?',
    ctaSubtitle: 'Contact us now and request a free quote',
    ctaButton: 'Request Quote'
  },

  // Gallery Page
  gallery: {
    title: 'Project Gallery',
    subtitle: 'Check out some of our completed works',
    categories: {
      all: 'All',
      toilet: 'Toilet',
      mosaic: 'Mosaic',
      pool: 'Pool',
      bedroom: 'Bedroom',
      shopping: 'Shopping'
    }
  },

  // Testimonials Page
  testimonials: {
    title: 'Testimonials',
    subtitle: 'See what our clients have to say about our services',
    avgRating: 'Average Rating',
    happyClients: 'Happy Clients',
    recommendation: 'Recommendation',
    ctaTitle: 'Want to Be Our Next Satisfied Client?',
    ctaSubtitle: 'Contact us and transform your space with quality and professionalism',
    ctaButton: 'Request Free Quote'
  },

  // Contact Page
  contact: {
    title: 'Get in Touch',
    subtitle: "We're ready to transform your space. Talk to us!",
    phone: 'Phone',
    email: 'Email',
    location: 'Location',
    hours: 'Hours',
    whatsappButton: 'Chat on WhatsApp',
    formTitle: 'Request Quote',
    form: {
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      service: 'Service of Interest',
      selectService: 'Select a service',
      message: 'Message',
      messagePlaceholder: 'Describe your project...',
      sendWhatsApp: 'Send via WhatsApp',
      sendEmail: 'Send by Email',
      other: 'Other'
    },
    faqTitle: 'Frequently Asked Questions',
    toastRedirect: 'Redirecting to WhatsApp!',
    toastDesc: 'You will be directed to send the message.'
  },

  // Footer
  footer: {
    description: 'Specialists in floor and tile solutions with excellence and quality for over 10 years.',
    quickLinks: 'Quick Links',
    contactTitle: 'Contact',
    socialMedia: 'Social Media',
    socialDesc: 'Follow us on social media and stay updated.',
    copyright: 'All rights reserved.'
  },

  common: {
    viewAll: 'View All Services',
    viewAllTestimonials: 'View All Testimonials',
    readMore: 'Read More',
    learnMore: 'Learn More'
  }
};